import { getTotalMachineValues } from '../helpers';
import { ACTION_TYPES } from '../../constants/protocol';

export const buildTelemetryAuditLog = ({
  points,
  isDc,
  deviceIds,
  swtName,
  startDate,
  endDate,
  machine,
}) => {
  const rows = points || [];
  const totalUsageHours = getTotalMachineValues(rows, 'hourOfUsage');
  const totalConsumption = Math.floor(
    rows.reduce((acc, cur) => acc + ((isDc ? cur.total : cur.consumption) || 0), 0),
  );

  return {
    actionType: isDc
      ? ACTION_TYPES.GLOBAL_DATA_TELEMETRY_OVERVIEW
      : ACTION_TYPES.GLOBAL_TELEMETRY_OVERVIEW,
    deviceIds,
    deviceType: swtName.toUpperCase(),
    data: {
      startDate,
      endDate,
      isDataConsumption: isDc,
      totalUsageHours,
      totalConsumption,
      data: {
        deviceId: machine,
        usageHours: totalUsageHours,
        consumption: totalConsumption,
      },
    },
  };
};
